import React, { useState, useEffect } from 'react';
import { Button, Form, Alert } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import { IoInformationCircle } from "react-icons/io5";
import { TbListDetails } from "react-icons/tb";

const EditDeptAnnouncements = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [announcement, setAnnouncement] = useState({
    title: '',
    content: '',
    department: '',
  });
  const [departments, setDepartments] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Fetch the existing announcement data to pre-fill the form
    const fetchAnnouncement = async () => {
      try {
        const response = await fetch(`http://localhost:5544/api/deptannouncements/${id}`);
        if (!response.ok) {
          throw new Error('Failed to fetch announcement data');
        }
        const data = await response.json();
        setAnnouncement({
          title: data.title || '',
          content: data.message || '',
          department: data.department || '',
        });
      } catch (error) {
        setError(error.message);
      }
    };

    fetchAnnouncement();
  }, [id]);

  useEffect(() => {
    // Fetch departments for dropdown
    const fetchDepartments = async () => {
      try {
        const response = await fetch(`http://localhost:5544/api/departments/`);
        if (!response.ok) {
          throw new Error('Failed to fetch departments');
        }
        const data = await response.json();
        setDepartments(data);
      } catch (error) {
        setError(error.message);
      }
    };

    fetchDepartments();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAnnouncement((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`http://localhost:5544/api/deptannouncements/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          title: announcement.title,
          message: announcement.content,
          department: announcement.department,
        }),
      });
      if (!response.ok) {
        throw new Error('Failed to update announcement');
      }
      setShowAlert(true);
      setTimeout(() => navigate('/dept-announcements'), 2000); // Redirect after successful update
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className='container-fluid'>
      <div className="edit-announcement-container">
        <h1 style={{ marginTop: '60px', fontSize: '2rem', color: '#0353a4' }}>
          <IoInformationCircle className="salary-icon" /> Announcements Information
        </h1>
        <hr />
        <h2 className="salary-subtitle">
          <TbListDetails className="salary-icon" /> Announcements Details
        </h2>
        <hr />
        <div className='table-container'>
          {showAlert && (
            <Alert variant="success" onClose={() => setShowAlert(false)} dismissible>
              <span className="moving-emoji">🎉</span> Announcement updated successfully!
            </Alert>
          )}
          {error && <Alert variant="danger">{error}</Alert>}

          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="title">
              <Form.Label>Title</Form.Label>
              <Form.Control
                type="text"
                name="title"
                value={announcement.title}
                onChange={handleChange}
                required
              />
            </Form.Group>
            <Form.Group controlId="content">
              <Form.Label>Content</Form.Label>
              <Form.Control
                as="textarea"
                name="content"
                value={announcement.content}
                onChange={handleChange}
                required
              />
            </Form.Group>
            <Form.Group controlId="department">
              <Form.Label>Department</Form.Label>
              <Form.Control
                as="select"
                name="department"
                value={announcement.department}
                onChange={handleChange}
                required
              >
                <option value="">Select a department</option>
                {departments.map((dept) => (
                  <option key={dept._id} value={dept.name}>{dept.name}</option>
                ))}
              </Form.Control>
            </Form.Group>
            <div className="py-3">
              <Button type="submit">Update Announcement</Button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default EditDeptAnnouncements;